export default [
  "#FF9172",
  "#386BD7",
  "#42BAFE",
  "#92B2F0",
  "#D9D9D9",
  "#0052CC",
  "#FFFFFF",
  "#C4C4C4",
];
